var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dy-wx-h5"},[_c('div',{staticClass:"dy-btn",on:{"click":_vm.handleClick}}),_c('img',{attrs:{"src":_vm.bgImg,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }